import cn from 'classnames';
import Image from 'next/legacy/image';
import Maybe from '@components/Maybe';
import styles from './skuimage.module.scss';

type SkuImageThumbnailProps = {
  image: string;
  imageClasses?: string;
  quantity?: number;
  showQty?: boolean;
};

const SkuImageThumbnail = ({ image, imageClasses = '', quantity = 1, showQty = false }: SkuImageThumbnailProps) => (
  <Maybe condition={image}>
    <div className={styles.imageWrapper}>
      <Image
        blurDataURL={image}
        placeholder="blur"
        quality={20}
        src={image}
        className={cn(imageClasses, styles.image)}
        alt="Sku Item"
        layout="fill"
        objectFit="cover"
      />
      {showQty && <div className={styles.quantity}>{quantity}</div>}
    </div>
  </Maybe>
);

export default SkuImageThumbnail;
